import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const taskVuex = createNamespacedHelpers("task");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
export default {
  name: "popNftShards",
  computed: {
    ...taskVuex.mapState(["timerObjs"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      dailyList: [],
      distance: 0,
      todayItem: null,
      dailyTaskList: null
    };
  },
  watch: {
    "$parent.popNFTTaskShow": {
      async handler(bool) {
        if (bool) {
          if (!this.dailyList || !this.todayItem) {
            return;
          }
          await this.onSignDaily();
        }
      },
      deep: true
    }
  },
  methods: {
    async getDailySign() {
      return new Promise(async resolve => {
        const res = await _v.$http.post("/daily/steps", {
          type: 10,
          refresh: 1
        });
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: {
        //     current_day: "2025-07-04",
        //     start_day: "2025-07-04",
        //     tomorrow_distance: 75863,
        //     cached: false,
        //     steps: [
        //       {
        //         name: "Day 1",
        //         fragments: 1,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: true,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 2",
        //         fragments: 1,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 3",
        //         fragments: 1,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "BIG DAY",
        //         fragments: 5,
        //         requirement: {
        //           dailyStock: 60,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 5",
        //         fragments: 2,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 6",
        //         fragments: 2,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 7",
        //         fragments: 2,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 8",
        //         fragments: 10,
        //         requirement: {
        //           dailyStock: 100,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //     ],
        //     task: null,
        //   },
        // };

        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async signDailyIn(params) {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/daily/complete", params);
        // const res = {
        //   code: 0,
        //   message: "",
        //   data: {
        //     current_day: "2025-07-04",
        //     start_day: "2025-07-04",
        //     tomorrow_distance: 75860,
        //     cached: false,
        //     steps: [
        //       {
        //         name: "Day 1",
        //         fragments: 1,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: true,
        //         completed: true,
        //         completed_count: 1,
        //         claimed: true,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 2",
        //         fragments: 1,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 3",
        //         fragments: 1,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "BIG DAY",
        //         fragments: 5,
        //         requirement: {
        //           dailyStock: 60,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 5",
        //         fragments: 2,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 6",
        //         fragments: 2,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 7",
        //         fragments: 2,
        //         requirement: {
        //           dailyStock: 20,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //       {
        //         name: "Day 8",
        //         fragments: 10,
        //         requirement: {
        //           dailyStock: 100,
        //         },
        //         today: false,
        //         completed: false,
        //         completed_count: 0,
        //         claimed: false,
        //         requirement_values: {
        //           dailyStock: 100000,
        //         },
        //       },
        //     ],
        //     task: {
        //       id: 150,
        //       user_id: 4129779,
        //       task_type: 10,
        //       completion_step: 1,
        //       completion_day: "2025-07-04",
        //       completion_time: 1751597740,
        //       completion_count: 1,
        //       claim_coins: 0,
        //       claim_stocks: 0,
        //       claim_fragments: 2,
        //       claim_steps: "0",
        //       claim_total_coins: 0,
        //       claim_total_stocks: 0,
        //       claim_total_fragments: 2,
        //       claim_time: 1751597740,
        //       created_at: "2025-07-04T02:55:40.000Z",
        //       updated_at: null,
        //       current_time: 1751597740,
        //       current_day: "2025-07-04",
        //       tomorrow_distance: 75860,
        //     },
        //     user: {
        //       id: 4129779,
        //       tg_id: "6605438145",
        //       username: "wjm12345",
        //       firstname: "wjm123",
        //       lastname: "",
        //       head_color: "#586c4c",
        //       avatar_url: null,
        //       total_reward: 0,
        //       extra_invite_count: 0,
        //       bind_wallet: "UQBaHGAc0mGxlAbnqvFQ1HBqVo5_8haeNaKcCUoJoPjIX0kb",
        //       coin: 9021000,
        //       diamond: 0,
        //       fragment: 2,
        //       stock: 100000,
        //       total_stock: 100000,
        //       ref_code: "7Fs2P4",
        //       user_level: 4,
        //       user_group_id: null,
        //       power_max: 1000,
        //       power: 1000,
        //       multi_tap: 1,
        //       turbo_temp_times: 0,
        //       turbo_temp: 0,
        //       turbo_count: 3,
        //       turbo_max: 3,
        //       refill_count: 3,
        //       refill_max: 3,
        //       multi_tap_level: 0,
        //       power_level: 0,
        //       recharge_speed: 1,
        //       recharge_speed_level: 0,
        //       auto_bot: 0,
        //       bot_level: 0,
        //       skin: "basic",
        //       joined_twitter: 0,
        //       joined_telegram: 0,
        //       joined_channel: 0,
        //       joined_discord: 0,
        //       ton_wallet: null,
        //       ton_gas_paid: 0,
        //       verified_premium: 0,
        //       verified_face: 0,
        //       verified_boost_channel: 0,
        //       verified_with_tapcoins: 0,
        //       app_center_tickets: 0,
        //     },
        //   },
        // };

        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data);
        }, () => {
          resolve();
        });
      });
    },
    async showReward(data) {
      console.log("datadatadatadata", data);
      this.$parent.rewardData = {
        count: data.fragments,
        balance: this.$parent.NFTBalance
      };
      console.log("this.$parent.rewardData", this.$parent.rewardData);
      await this.$parent.getNFTBalance();
      this.$parent.rewardData = {
        ...this.$parent.rewardData,
        newBalance: this.$parent.NFTBalance
      };
      console.log("this.$parent.rewardData1111", this.$parent.rewardData);
      this.$nextTick(() => {
        this.$parent.popRewardShow = true;
      });
    },
    async onSignDaily() {
      if (!this.todayItem.completed && this.todayItem.requirement_values.dailyStock >= this.todayItem.requirement.dailyStock) {
        const res = await this.signDailyIn({
          type: 10,
          multiple: 1
        });
        if (!res) {
          return;
        }
        res.steps.map(item => {
          if (item.today) {
            this.todayItem = item;
          }
        });
        this.dailyList = res.steps;
        this.showReward(this.todayItem);
        this.distance = res.tomorrow_distance;
        this.countDown();
      }
    },
    async initFn() {
      let res = await this.getDailySign();
      if (!res) {
        return;
      }
      res.steps.map(item => {
        if (item.today) {
          this.todayItem = item;
        }
      });
      this.dailyList = res.steps;
      this.distance = res.tomorrow_distance;
      this.countDown();
    },
    countDown() {
      clearTimeout(this.timerObjs.NFTPage.NFTDailyTimer);
      if (this.distance > 0) {
        this.distance--;
      }
      if (this.distance <= 0) {
        clearTimeout(this.timerObjs.NFTPage.NFTDailyTimer);
        this.initFn();
        return;
      }
      this.timerObjs.NFTPage.NFTDailyTimer = setTimeout(() => {
        this.countDown();
      }, 1000);
    }
  },
  mounted() {
    this.initFn();
  }
};